module.exports = __webpack_public_path__ + "static/img/phoneCall.919da4a3.svg";